'use client';

import React from 'react';
import { RegFormField } from '@/features/b2b/register/components/RegFormField';

export const PersonalDetailsSection = ({ formData, handleInputChange, errors }) => {
  return (
    <>
      <RegFormField
        label="Job title"
        name="jobTitle"
        value={formData.jobTitle}
        onChange={handleInputChange}
        placeholder="Enter your job title"
        error={errors.jobTitle}
      />

      <RegFormField
        label="Mobile number"
        name="mobileNo"
        type="tel"
        value={formData.mobileNo}
        onChange={handleInputChange}
        placeholder="07845 657 125"
        error={errors.mobileNo}
      />

      <RegFormField
        label="Case updates"
        name="caseUpdates"
        type="email"
        value={formData.caseUpdates}
        onChange={handleInputChange}
        placeholder="Example@example.com"
      />

      <RegFormField
        label="Commission statement"
        name="commStat"
        type="email"
        value={formData.commStat}
        onChange={handleInputChange}
        placeholder="Example@example.com"
      />

      <RegFormField
        label="Marketing"
        name="marketing"
        type="email"
        value={formData.marketing}
        onChange={handleInputChange}
        placeholder="Example@example.com"
      />
    </>
  );
};
